import { ObservableMap } from '@stencil/store';
import { State } from 'app/shared/store/models/state.model';
import { removeHandler } from 'app/shared/store/handlers/types/remove-handler';
import { flowService } from 'app/shared/services/flow/flow-service';

export const flowTypeHandler = (store: ObservableMap<State>): removeHandler => {
  return store.onChange('flowType', (flowType) => {
    flowService.setFlowType(flowType);
  });
};

export const addressRequiredHandler = (store: ObservableMap<State>): removeHandler => {
  return store.onChange('addressRequired', (addressRequired) => {
    flowService.setAddressRequired(addressRequired);
  });
};
